////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { filter } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
///////COMPONENTS///////
import Button from '../../../../components/Ui/Buttons'
import theme from '../../../../theme/theme'
import Modals from '../../../../components/Modals'
import StringFormatter from '../../../../helpers/StringFormatter'
import { articleLifeManagerActionCreators } from '../../../../store/actions'
/////////ASSETS/////////
import Validation from '../../../../assets/icones/global/check.svg'
import Cancel from '../../../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ModalDeleteWrapper = styled.div``
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
const TextTopWrapper = styled.div`
	margin: 15px 0;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const TextModalCustom = styled.div`
	padding: 0;
	width: 555px;
`
/////////STYLED/////////
// [63]_a): INSTANT DESACTIVE

const ModalUnactive = (props) => {
	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())
	const id = props.unactive.item.header.id
	let query = ''
	if (filter(props.unactive.item.header.actionsOnItem, (elem) => elem.query === 'Unactive')) {
		query = 'Unactive'
	}

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleDeleteItem = () => {
		actionsArticleLifeManager.postUnactiveItem(id, query, moment().toDate())
		props.unactive.close()
	}

	const concat = `<span style="color:	${theme.colors.primary}" > [${props.unactive.item.header.itemRefLabel}] </span>`
	let text = StringFormatter.ResponseMessageParser(translations['modal__itemRef__timeline_action_deactivateNow_message'], [concat])

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.unactive.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalDeleteWrapper>
			<Modals
				showModal={props.unactive.show}
				closeModalHandler={props.unactive.close}
				level="error"
				icon={true}
				title={translations['modal__itemRef__timeline_action_deactivateNow_title']}
				width={555}
			>
				<TextTopWrapper>
					<TextModalWrapper>
						<TextModalCustom dangerouslySetInnerHTML={{ __html: text }}></TextModalCustom>
					</TextModalWrapper>
				</TextTopWrapper>

				<ButtonWrapper>
					<Button
						actionHandler={props.unactive.close}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={handleDeleteItem}
						text={translations['modal__itemRef__timeline_action_deactivateNow_buttons_validate']}
						bgColor={theme.colors.validation}
						img={Validation}
						width={250}
					/>
				</ButtonWrapper>
			</Modals>
		</ModalDeleteWrapper>
	)
}

ModalUnactive.propTypes = {}

ModalUnactive.defaultPropTypes = {}

export default ModalUnactive
